export enum Directions {
  Up = `up`,
  UpRight = `upRight`,
  Down = `down`,
  DownRight = `downRight`,
  Right = `right`,
  Left = `left`,
  CenterUp = `centerUp`,
  CenterDown = `centerDown`,
  CenterRight = `centerRight`,
}

export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum PositionParentType {
  OffsetParent = `offsetParent`,
  ParentElement = `parentElement`,
}

// use "const enum" for backward compatibility with raw menu state strings
// "const enum" forces Typescript to simply inline the enum value when compiled
export const enum MenuState {
  Open = `open`,
  Closed = `closed`,
}
